import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    IAgeLevel,
    IAPIResponse,
    IDesignation,
    ILeague,
    ILeagueDirection,
    ITeam,
    IUser,
    TLeagueSeasons,
    TLeagueYears,
} from "../../types/api";
import { alertActions } from "../alert/alertSlice";
import {
    getLeagues as getLeaguesFromAPI,
    getYears as getYearsFromAPI,
    getDesignations as getDesignationsFromAPI,
    getLeagueDirections as getLeagueDirections,
} from "../../lib/api";
import { store } from "../..";
import { globalActions, selectSetting } from "../global/globalSlice";

interface IGetLeaguesResponse extends IAPIResponse {
    leagues: ILeague[];
}

interface IGetYearsResponse extends IAPIResponse {
    years: {
        [year in TLeagueYears]: {
            [season in TLeagueSeasons]: IAgeLevel["ageLevel"][];
        };
    };
}

export const getLeagues = createAsyncThunk<
    IGetLeaguesResponse,
    ILeague["year"] | undefined,
    { rejectValue: string }
>(
    "leaguemanagement/getLeagues",
    async (year, { rejectWithValue, dispatch }) => {
        let settings = store.getState().global.settings;
        if (!year) {
            if (!settings.length) {
                await dispatch(globalActions.getSettings());
                settings = store.getState().global.settings;
            }

            const yearSetting = selectSetting(
                store.getState(),
                "majorybl_current_league_year",
            );
            year = parseInt(yearSetting?.setting);
        }

        try {
            const response = await getLeaguesFromAPI(year);

            return response;
        } catch (e) {
            const error = e as string;
            // dispatch(
            //     alertActions.error({
            //         level: "danger",
            //         text: "Team retrieval failed. Please try again later or contact an admin",
            //         title: error,
            //     }),
            // );
            return rejectWithValue(error);
        }
    },
);

export const getYears = createAsyncThunk<
    IGetYearsResponse,
    void,
    { rejectValue: string }
>("leaguemanagement/getYears", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getYearsFromAPI();

        return response;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "Team retrieval failed. Please try again later or contact an admin",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});

export const getDesignations = createAsyncThunk<
    IAPIResponse & {
        designations: IDesignation[];
    },
    void,
    { rejectValue: string }
>(
    "leaguemanagement/getDesignations",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const response = await getDesignationsFromAPI();

            return response;
        } catch (e) {
            const error = e as string;
            return rejectWithValue(error);
        }
    },
);

export const getDirections = createAsyncThunk<
    IAPIResponse & {
        directions: ILeagueDirection[];
    },
    void,
    { rejectValue: string }
>(
    "leaguemanagement/getDirections",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const response = await getLeagueDirections();

            return response;
        } catch (e) {
            const error = e as string;
            return rejectWithValue(error);
        }
    },
);
